"use client";

import React from "react";
import NextLink from "next/link";
import {Locale} from "@/i18n-config";
import type {ContentLink as ContentLinkProps} from "@docid/types/src/payload-types";
import {localizePathname} from "@/utils/locales";
import {useSearchParams} from "next/navigation";
import clsx from "clsx";

type Props = {
    lang: Locale;
    dictionary: any;
    className?: string;
    block: ContentLinkProps;
    position?: number;
};

export function ContentLink({ lang, dictionary, className, block, position } : Props) {
    const searchParams = useSearchParams();
    switch(block.linkType) {
        case "Internal":
            return (
                <NextLink
                    className={clsx(className)}
                    href={localizePathname(lang, block.pathname!, searchParams)}
                    target={block.openInNewTab === "Yes" ? "_blank" : "_self"}
                    rel={block.noFollow ? "nofollow" : ""}>
                    {block.name}
                </NextLink>
            );
        case "External":
            return (
                <a
                    className={clsx(className)}
                    href={block.externalLink!}
                    target={block.openInNewTab === "Yes" ? "_blank" : "_self"}
                    rel={block.noFollow ? "nofollow" : ""}>
                    {block.name}
                </a>
            );
        default:
            return (
                <div className={clsx(className)}>
                    {block.name}
                </div>
            );
    }
}